export default __webpack_public_path__ + "static/media/archywavelogo1.a56faffa.png";